import { ConfirmationDialog } from "ui/confirmation-dialog";

import { useClaimVersionLock, useBuilderContent } from "hooks/api/use-touchpoint-versions";

import { useCurrentClient } from "hooks/api/use-clients";
import { useCurrentCampaign } from "hooks/api/use-campaigns";
import { useCurrentTouchpoint } from "hooks/api/use-current-touchpoint";

interface LockRleaseModalProps {
  onCloseCallback?: () => void;
}

export const LockReleaseModal = ({ onCloseCallback }: LockRleaseModalProps) => {
  const currentClient = useCurrentClient();
  const currentCampaign = useCurrentCampaign();
  const currentTouchpoint = useCurrentTouchpoint();
  const touchpointContent = useBuilderContent();
  const claimLockMutation = useClaimVersionLock({
    clientId: currentClient.id,
    campaignId: currentCampaign.id,
    touchpointId: currentTouchpoint.id,
  });
  const handleRefreshPage = async () => {
    try {
      await claimLockMutation.mutateAsync(touchpointContent?.id as string);
    } catch (error) {
      console.error("Failed to reclaim touchpoint lock before refresh", error);
    } finally {
      window.location.reload();
    }
  };

  return (
    <ConfirmationDialog
      open
      intent="warning"
      onClose={() => onCloseCallback?.()}
      onConfirm={handleRefreshPage}
      headline="Your session has been inactive"
      message="Other users might have changed touchpoint version. Please refresh page to ensure you are working with latest version."
      confirmButtonText="Refresh page"
      cancelButtonText="Exit builder"
      closable={false}
    />
  );
};

export default LockReleaseModal;
